import React from 'react';

interface Advantage {
  icon: string;
  alt: string;
  title: string;
  description: string;
}

interface AdvantagesSectionProps {
  title: string;
  description: string;
  advantages: Advantage[];
}

const AdvantagesSection: React.FC<AdvantagesSectionProps> = ({
  title,
  description,
  advantages
}) => {
  return (
    <div className="md:space-y-10 space-y-4 pt-4">
      <h3 className="font-extrabold xl:text-[36px] text-[26px] text-first text-center">
        {title}
      </h3>
      <div className="grid md:grid-cols-3 grid-cols-1 gap-4">
        {advantages.map((advantage, index) => (
          <div key={index} className="flex items-center text-first gap-x-2">
            <img
              src={advantage.icon}
              alt={advantage.alt}
              className="md:w-[150px] md:h-[150px] w-[80px] h-[80px]"
            />
            <div className="text-normal">
              <span className="font-bold">
                {advantage.title}
              </span>
              <p className="text-normal">
                {advantage.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdvantagesSection; 